import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';

import Button from '../../../../../components/global/Button';
import PinField from '../../../../../components/global/PinField';

const propTypes = {
  values: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
    phone_number: PropTypes.string,
    code: PropTypes.string,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  onPinCodeResend: PropTypes.func.isRequired,
};

const EmailPinVerifyForm = ({
  values,
  loading,
  handleSubmit,
  handleChange,
  onPinCodeResend,
}) => {
  useEffect(() => {
    onPinCodeResend();
  }, []);

  const isValid = values.code?.length === 4;

  return (
    <Fragment>
      <h4 className="text-center">
        Please enter the code sent to <br />
        <span className="text-primary">{values.email}</span>.
      </h4>
      <form
        onSubmit={handleSubmit}
        className="d-flex flex-column align-items-center"
      >
        <div className="mb-2">
          <PinField
            onComplete={value => {
              handleChange({
                target: {
                  name: 'code',
                  value,
                },
              });
            }}
            onChange={value => {
              handleChange({
                target: {
                  name: 'code',
                  value,
                },
              });
            }}
          />
        </div>

        <Button type="submit" btnBlock disabled={loading || !isValid}>
          {loading ? 'Processing...' : 'Submit'}
        </Button>

        <Button
          type="button"
          btnStyle="link"
          disabled={loading}
          loading={loading}
          className="text-extra-bold mt-2"
          onClick={() => onPinCodeResend(values)}
        >
          Re&ndash;send code
        </Button>
      </form>
    </Fragment>
  );
};

EmailPinVerifyForm.propTypes = propTypes;

export default EmailPinVerifyForm;
